import React from 'react';
import { Section } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { CtaButton } from '../ui/CtaButton';
import { CTA_URL } from '../../data/content';
export function ProductIntro() {
  return <Section className="bg-white" width="narrow" aria-labelledby="producto-titulo" data-id="element-272" data-mp="2fh2h1otnfzcl">
      <Reveal data-id="element-273" data-mp="2ager76h5pojy">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-274" data-mp="2afv8hnjomw4v">Presentamos</p>
        <h2 id="producto-titulo" className="mt-4 text-[2rem] font-extrabold leading-[1.1] tracking-tight text-forest sm:text-5xl" data-id="element-275" data-mp="2pd5i0rcrlrxy">
          Método Glucosa Estable
        </h2>
        <p className="mt-5 text-lg leading-snug text-ink sm:text-xl" data-id="element-276" data-mp="2y70nk0hstke4">
          El código anti-antojos para energía estable y grasa bloqueada, desbloqueada.
        </p>
      </Reveal>

      <Reveal delay={0.08} data-id="element-277" data-mp="384olt0em5a11">
        <p className="mt-8 text-base leading-relaxed text-body sm:text-lg" data-id="element-278" data-mp="383vnmntpzsui">
          No es una dieta. Es un protocolo de{' '}
          <strong className="font-bold text-forest" data-id="element-279" data-mp="33758c2pqp1a5">secuenciación de alimentos</strong>: el orden
          exacto en que comes lo que ya está en tu plato. Fibra primero, proteína y grasa después,
          carbohidrato al final. Mismo plato, misma cantidad — respuesta hormonal completamente
          distinta. Esa es toda la mecánica, y es lo que apaga el antojo de las 4 PM sin que tengas
          que renunciar a nada.
        </p>
      </Reveal>

      <Reveal delay={0.12} data-id="element-280" data-mp="2z4j2hsl26ef7">
        <figure className="mt-9" data-id="element-281" data-mp="2z383s76gzwuy">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/19ed99a3-8268-4287-bf34-39f7078941d3.jpg" alt="Tres platos sobre mármol mostrando el orden de la comida: primero vegetales, luego proteína y grasa, y al final el carbohidrato" className="w-full rounded-2xl object-cover shadow-card" width={1456} height={816} loading="lazy" data-id="element-282" data-mp="2z25chy58jsei" />
          <figcaption className="mt-4 grid grid-cols-3 gap-3 text-center" data-id="element-283" data-mp="3hvip4n52zc5b">
            {[{
            step: '1',
            label: 'Fibra'
          }, {
            step: '2',
            label: 'Proteína y grasa'
          }, {
            step: '3',
            label: 'Carbohidrato'
          }].map(item => <span key={item.step} className="text-xs text-muted" data-id="element-284" data-mp="1iqsfqgzkjf8b">
                <strong className="block text-sm font-bold text-forest" data-id="element-285" data-mp="1whe0ycchw19d">{item.step}</strong>
                {item.label}
              </span>)}
          </figcaption>
        </figure>
      </Reveal>

      <Reveal delay={0.16} data-id="element-286" data-mp="26fjyyiv6kn8y">
        <div className="mt-9" data-id="element-287" data-mp="26esfg6euyfz1">
          <CtaButton href={CTA_URL} data-id="element-288" data-mp="26e0iar5m4a6n">Muéstrame Cómo Aplicar El Código</CtaButton>
        </div>
      </Reveal>
    </Section>;
}